import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../store'

const baseQuery = fetchBaseQuery({
  baseUrl: 'https://admin2.gcbuying.com/api',
  prepareHeaders: (headers, { getState }) => {
    headers.set(
      'authorization',
      'Bearer 0f0cb92cf5860fe79b98f72421a4014ef08808087a64f2a77eaded24eaea31cdd98c23eb22f0ff511613c53300547807edd67f30df7db26553067ef501d679bc8e2d9fd788234b4ebe8bfdc3577c8537bd70a69532e4491fe217f72f276a39a48600291785498857d0f6d7ce930693298cfb78ae85e82cc3f54a8c269f0c3e49'
    )

    return headers
  },
})

export const strapiApiSlice = createApi({
  reducerPath: 'strapi',
  baseQuery: baseQuery,
  endpoints: builder => ({}),
  tagTypes: ['Blogs', 'Announcements'],
})
